<template>
  <v-snackbar v-model="snackbar" v-bind="props">
      {{message}}
  </v-snackbar>
</template>

<script>
export default {
    watch: {
        isMobile() {
            this.hideSnackbar()
        },
    },
    data() {
        return {
            snackbar: false,
            message: '',
            props: null
        }
    },
    methods: {
        hideSnackbar() {
            this.snackbar = false
            this.$nextTick(()=>{
                this.message = ''
                this.props = null
            })
        }
    },
    created() {
        this.$eventBus.$on('snackbar:open', data => {


            /** TODO параметры для ширины компонента сломались, пока отключаю до починки */

/*             this.message = data.message
            
            
            let props = Object.assign({
                app: true,
                width: 200
            }, data.props)
            
              
            this.props = props




            this.snackbar = true */
        })

        this.$eventBus.$on('snackbar:close', data => {
            this.hideSnackbar()
        })
    }
}
</script>

<style>

</style>